import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
// import { Dots } from "../../svg";

export default function ProfileMenu() {
  const { username } = useParams();
  const location = useLocation();
  const { user } = useSelector((state) => ({ ...state }));
  
  // Use current user's username if no username in URL
  const effectiveUsername = username || user?.username;
  const baseUrl = effectiveUsername ? `/profile/${effectiveUsername}` : '/profile';
  
  // Determine the current tab based on the URL
  const currentPath = location.pathname;
  
  // More precise tab detection
  const isPostsTab = currentPath === `/profile/${username}` || 
                    currentPath === '/profile' || 
                    (currentPath === `/profile/${effectiveUsername}` && 
                     !currentPath.includes('/about') && 
                     !currentPath.includes('/friends') && 
                    !currentPath.includes('/photos') && 
                    !currentPath.includes('/videos') && 
                    !currentPath.includes('/tagged') && 
                    !currentPath.includes('/highlights') && 
                    !currentPath.includes('/archive') && 
                    !currentPath.includes('/more'));
  
  const isAboutTab = currentPath.includes('/about');
  const isFriendsTab = currentPath.includes('/friends');
  const isPhotosTab = currentPath.includes('/photos');
  const isVideosTab = currentPath.includes('/videos');
  const isTaggedTab = currentPath.includes('/tagged');
  const isHighlightsTab = currentPath.includes('/highlights');
  const isArchiveTab = currentPath.includes('/archive');
  const isOwnProfile = !username || username === user?.username;

  return (
    <div className="profile_menu_wrap">
      <div className="profile_menu">
        <Link 
          to={baseUrl} 
          className={isPostsTab ? "profile_menu_active" : "hover1"}
        >
          Publication
        </Link>
        <Link 
          to={`${baseUrl}/about`} 
          className={isAboutTab ? "profile_menu_active" : "hover1"}
        >
          About
        </Link>
        <Link 
          to={`${baseUrl}/friends`} 
          className={isFriendsTab ? "profile_menu_active" : "hover1"}
        >
          Friends
        </Link>
        <Link 
          to={`${baseUrl}/photos`} 
          className={isPhotosTab ? "profile_menu_active" : "hover1"}
        >
          Photos
        </Link>
        <Link 
          to={`${baseUrl}/videos`} 
          className={isVideosTab ? "profile_menu_active" : "hover1"}
        >
          Videos
        </Link>
        <Link 
          to={`${baseUrl}/tagged`} 
          className={isTaggedTab ? "profile_menu_active" : "hover1"}
        >
          Tagged
        </Link>
        <Link 
          to={`${baseUrl}/highlights`} 
          className={isHighlightsTab ? "profile_menu_active" : "hover1"}
        >
          Memories
        </Link>
        {isOwnProfile && (
          <Link 
            to={`${baseUrl}/archive`} 
            className={isArchiveTab ? "profile_menu_active" : "hover1"}
          >
            Archive
          </Link>
        )}
        {/* <Link 
          to={`${baseUrl}/more`} 
          className={isMoreTab ? "profile_menu_active" : "hover1"}
        >
          More
        </Link> */}
        {/* <div className="p10_dots">
          <Dots />
        </div> */}
      </div>
    </div>
  );
}
